// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/patternimg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.points_main_div {
    position: absolute;
    width: 45%;
    height: 13rem;
    border-radius: 18px;
    background-image: linear-gradient(to right top, #0098b8, #6eb647, #000000, #64bacc, #6eb647);
}
.points_div {
    position: relative;
    font-size: 34px;
    height: 100%;
    padding: 1.5rem 1rem 1.5rem 1rem;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 8.95px 10.6px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.coin_image{
    position: absolute;
    top: -27px;
    right: -21px;
    margin: 0;
    opacity: 0.75;
}
.earned_coin {
    width: fit-content;
    text-align: left;
    position: absolute;
    font-weight: 500;
    font-size: 28px;
    color: rgb(241, 241, 241);
    left: 20px;
    display: flex;
    justify-content: left;
    background-color: #42424287;
    padding: 4px 0.25rem;
    border-radius: 0.25rem;
}
/* .earned_coin {
    width: 4rem;
    text-align: left;
    position: absolute;
    font-weight: 500;
    font-size: 28px;
    color: rgb(241, 241, 241);
    left: 20px;
    display: flex;
    justify-content: left;
    background-color: #14501487;
    padding: 4px 0.25rem;
    border-radius: 0.25rem;
} */
.points{
    width: 3rem;
    text-align: left;
    font-size: 10px;
    color: rgb(255, 255, 255);
}
.discount_text {
    font-size: 13.5px;
    position: absolute;
    top: 10.25rem;
    color: rgb(255, 255, 255);
}
.reward_Card{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 17rem;
}
.reward_news{
    top: 0;
    position: relative;
}

@media only screen and (min-width: 2560px), (max-width: 2560px) {
    .points_main_div{
        width: 25rem;
    }
}

@media only screen and (max-width: 768px) {
    .card{
        margin-right: 1rem;
    }
}
@media screen and (max-width: 480px) {
    .points_main_div {
        right: -7.5%;
    }
    .discount_text {
        font-size: 12px;
    }
    .card{
        border: none;
    }
    .coin_image{
        width: 8rem;
        height: 8rem;
        top: -15px;
        right: -9px;
        margin: 0;
    }

    .reward_news{
        top: -3.8rem;
    }
  }

  @media only screen and (max-width: 425px) {
    .points_main_div{
        width: 22rem;
    }
}
  @media only screen and (max-width: 350px) {
    .discount_text{
        font-size: 9.6px;
        top: 9rem;
    }
    .points_main_div{
        width: 18rem;
        height: 11rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/Css/rewards.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,4FAA4F;AAChG;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,oDAAoD;IACpD,yDAA+C;IAC/C,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;;;;;;;;;;;;;GAaG;AACH;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,MAAM;IACN,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,WAAW;QACX,SAAS;IACb;;IAEA;QACI,YAAY;IAChB;EACF;;EAEA;IACE;QACI,YAAY;IAChB;AACJ;EACE;IACE;QACI,gBAAgB;QAChB,SAAS;IACb;IACA;QACI,YAAY;QACZ,aAAa;IACjB;AACJ","sourcesContent":[".points_main_div {\n    position: absolute;\n    width: 45%;\n    height: 13rem;\n    border-radius: 18px;\n    background-image: linear-gradient(to right top, #0098b8, #6eb647, #000000, #64bacc, #6eb647);\n}\n.points_div {\n    position: relative;\n    font-size: 34px;\n    height: 100%;\n    padding: 1.5rem 1rem 1.5rem 1rem;\n    border-radius: 18px;\n    overflow: hidden;\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 8.95px 10.6px;\n    background-image: url(\"/public/patternimg.png\");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.coin_image{\n    position: absolute;\n    top: -27px;\n    right: -21px;\n    margin: 0;\n    opacity: 0.75;\n}\n.earned_coin {\n    width: fit-content;\n    text-align: left;\n    position: absolute;\n    font-weight: 500;\n    font-size: 28px;\n    color: rgb(241, 241, 241);\n    left: 20px;\n    display: flex;\n    justify-content: left;\n    background-color: #42424287;\n    padding: 4px 0.25rem;\n    border-radius: 0.25rem;\n}\n/* .earned_coin {\n    width: 4rem;\n    text-align: left;\n    position: absolute;\n    font-weight: 500;\n    font-size: 28px;\n    color: rgb(241, 241, 241);\n    left: 20px;\n    display: flex;\n    justify-content: left;\n    background-color: #14501487;\n    padding: 4px 0.25rem;\n    border-radius: 0.25rem;\n} */\n.points{\n    width: 3rem;\n    text-align: left;\n    font-size: 10px;\n    color: rgb(255, 255, 255);\n}\n.discount_text {\n    font-size: 13.5px;\n    position: absolute;\n    top: 10.25rem;\n    color: rgb(255, 255, 255);\n}\n.reward_Card{\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 17rem;\n}\n.reward_news{\n    top: 0;\n    position: relative;\n}\n\n@media only screen and (min-width: 2560px), (max-width: 2560px) {\n    .points_main_div{\n        width: 25rem;\n    }\n}\n\n@media only screen and (max-width: 768px) {\n    .card{\n        margin-right: 1rem;\n    }\n}\n@media screen and (max-width: 480px) {\n    .points_main_div {\n        right: -7.5%;\n    }\n    .discount_text {\n        font-size: 12px;\n    }\n    .card{\n        border: none;\n    }\n    .coin_image{\n        width: 8rem;\n        height: 8rem;\n        top: -15px;\n        right: -9px;\n        margin: 0;\n    }\n\n    .reward_news{\n        top: -3.8rem;\n    }\n  }\n\n  @media only screen and (max-width: 425px) {\n    .points_main_div{\n        width: 22rem;\n    }\n}\n  @media only screen and (max-width: 350px) {\n    .discount_text{\n        font-size: 9.6px;\n        top: 9rem;\n    }\n    .points_main_div{\n        width: 18rem;\n        height: 11rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
